import angular from 'angular';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import adminpulse from '../../../shared/utils/adminpulse';
import moment from 'moment';

angular
  .module('cloudX')
  .controller('AddCommonTaskSchedulesDialogCtrl', [
    '$http',
    '$q',
    'flySvc',
    '$element',
    'appUrls',
    'close',
    'streamId',
    'relationId',
    'relType',
    'existingSchedules',
    'invoiceStreams',
    'dialogsSvc',
    'translateListFilter',
    addCommonTaskSchedulesDialogCtrl,
  ]);

function addCommonTaskSchedulesDialogCtrl(
  $http,
  $q,
  flySvc,
  $element,
  appUrls,
  close,
  streamId,
  relationId,
  relType,
  existingSchedules,
  invoiceStreams,
  dialogsSvc,
  translateListFilter,
) {
  var vm = this;
  vm.lines = [];
  vm.templates = [];
  vm.showScheduleDate = false;
  vm.invoiceStreams = invoiceStreams;
  vm.showValidation = false;

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters, null, error.data.type);
    return '';
  };

  function Schedule() {
    this.invoiceStreamId = streamId;
    this.relationId = relationId;
    this.type = 1;
    this.template = null;
    this.periodicity = null;
    this.planningStart = new Date();
    this.planningStop = null;
    this.scheduleDate = null;
  }

  $http
    .get(`${appUrls.tasks}/Api/TaskTemplates/Schedules?relationType=${relType}`)
    .then(function(response) {
      vm.templates = response.data
        .map(x => ({
          ...x,
          label: translateListFilter(x.id, 'tasktemplate', x.name),
          periodicities: (x.periodicities || [])
            .map(p => ({
              ...p,
              label: translateListFilter(p.id, 'taskperiodicity', p.name),
            }))
            .sort(dynamicSort('label')),
        }))
        .sort(dynamicSort('label'));
      for (var i = 0; i < vm.templates.length; i++) {
        if (
          (relType === 0 && vm.templates[i].appliesToCompany) ||
          (relType === 1 && vm.templates[i].appliesToSoleProprietor) ||
          (relType === 2 && vm.templates[i].appliesToPerson)
        ) {
          var schedule = new Schedule();
          schedule.template = vm.templates[i];
          vm.templateChanged(schedule);
          vm.lines.push(schedule);
        }
      }

      var notApplicableTemplates = vm.templates.filter(function(el) {
        if (
          (relType === 0 && !el.appliesToCompany) ||
          (relType === 1 && !el.appliesToSoleProprietor) ||
          (relType === 2 && !el.appliesToPerson)
        )
          return true;
        return false;
      });

      for (var x = 0; x < notApplicableTemplates.length; x++) {
        var idx = vm.templates.indexOf(notApplicableTemplates[x]);
        if (idx >= 0) vm.templates.splice(idx, 1);
      }

      if (vm.lines.length === 0) vm.lines.push(new Schedule()); //Show at least 1 schedule to add

      vm.resetShowScheduleDate();
    }, showError);

  vm.templateChanged = function(item) {
    if (!item.template || !item.template.periodicities) {
      item.periodicity = null;
      vm.resetShowScheduleDate();
      return;
    }
    if (item.template.periodicities.length > 0) {
      item.periodicity = item.template.periodicities[0];
    }
    vm.resetShowScheduleDate();
  };
  vm.resetShowScheduleDate = function() {
    vm.showScheduleDate = vm.lines.some(x => x.periodicity && x.periodicity.showScheduleDate);
  };
  vm.periodicityChanged = function(item) {
    if (item.periodicity && item.periodicity.showScheduleDate) {
      vm.showScheduleDate = true;
    } else {
      item.scheduleDate = null;
      vm.resetShowScheduleDate();
    }
  };
  vm.saving = false;

  var addSchedule = function(schedule) {
    return $http.post(appUrls.tasks + '/Api/TaskSchedules/', schedule).then(
      function(response) {
        return response.data;
      },
      function(error) {
        showError(error);
        return null;
      },
    );
  };

  vm.scheduleExists = function(model) {
    if (!model || !model.periodicity || !model.template) return false;
    if (model.periodicity.showScheduleDate) return false;
    if (
      vm.lines.some(
        schedule =>
          schedule !== model &&
          schedule.periodicity.id === model.periodicity.id &&
          schedule.template.id === model.template.id,
      )
    )
      return true;
    if (!existingSchedules) return false;
    return existingSchedules.some(function(schedule) {
      return (
        schedule.periodicity.id === model.periodicity.id &&
        schedule.template.id === model.template.id
      );
    });
  };
  vm.validate = function() {
    for (var i = 0; i < vm.lines.length - 1; i++) {
      var line = vm.lines[i];
      for (var j = i + 1; j < vm.lines.length; j++) {
        var other = vm.lines[j];
        if (line.periodicity.id === other.periodicity.id && line.template.id === other.template.id)
          return false;
      }
    }
    return true;
  };
  vm.save = function() {
    if (vm.saving) return;
    vm.saving = true;
    $q.all(
      vm.lines.map(function(item) {
        var model = angular.copy(item);
        if (model.planningStart instanceof Date)
          model.planningStart = moment.utc(model.planningStart);
        if (model.planningStop && model.planningStop instanceof Date)
          model.planningStop = moment.utc(model.planningStop);

        if (model.scheduleDate && model.scheduleDate instanceof Date)
          model.scheduleDate = moment.utc(model.scheduleDate);
        return addSchedule(model);
      }),
    )
      .then(function(data) {
        //Keep dialog open if all the schedules contain errors
        if (
          data.length > 0 &&
          data.every(function(element) {
            return element === null;
          }) === true
        )
          return;

        $element.modal('hide');
        close(data, 500);
      })
      .finally(function() {
        vm.saving = false;
      });
  };
  vm.removeItem = function(item) {
    var idx = vm.lines.indexOf(item);
    if (idx >= 0) vm.lines.splice(idx, 1);
    vm.resetShowScheduleDate();
  };
  vm.cancel = function() {
    close(null, 500);
  };
  // vm.scheduleDateChanged = function(item) {
  //   item.scheduleDate = adminpulse.dayMonthDate(item.scheduleDate);
  // };
  vm.dayMonthOptions = {
    minMode: 'day',
    maxMode: 'month',
    showWeeks: false,
    formatDayTitle: 'MMMM',
    datepickerMode: 'month',
    formatMonthTitle: ' ',
    initDate: new Date(2000, 11, 31),
    // minDate: new Date(2000, 0, 1),
    // maxDate: new Date(2000, 11, 31),
  };
}
